import { createContext } from 'react';

import { Item } from './Item';

export interface AddSingleItemContextType {
  selectableItems: Item[];
}

export const AddSingleItemContext = createContext<AddSingleItemContextType>({
  selectableItems: [],
});
